import React from "react";

/**
 * Patrick Hand accent — Brand Guidelines:
 * 20–28pt, max ONE per layout/section, ONE LINE, never paragraphs.
 * Typically Heart Teal on light; Sunshine only on Spectrum Blue (large/headline contexts).
 */
const AccentText = ({
  children,
  tone = "teal",
  className = "",
}) => {
  const color =
    tone === "sunshine"
      ? "text-sunshine"
      : tone === "white"
        ? "text-surface-white"
        : tone === "blue"
          ? "text-spectrum-blue"
          : "text-heart-teal";

  return (
    <p
      className={`font-accent-hand text-[22px] leading-tight text-left whitespace-nowrap ${color} ${className}`}
    >
      {children}
    </p>
  );
};

export default AccentText;
